module.exports = __webpack_public_path__ + "images/94abd2482930c451b496afa81f761840-lacoleccion.png";